module.exports = __webpack_public_path__ + "img/af0fd4c.png";